import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';


const ButtonLoader = () => {
  return (
      <div className="button-loader">
        <FontAwesomeIcon
          className="button-loader-icon"
          icon={faSpinner}
          spin
          size="lg"
        />
      </div>
  );
};


export default ButtonLoader;